export default "__VITE_ASSET__BzMqluET__"